<template>
    <div id="securityInformationTrafficSupport">
        <div class="container">
            <div class="row m-0 pl-md-5 pr-md-5">
                <div class="col-lg-6 text-center pt-5 mt-5 mb-5">
                    <font-awesome-icon icon="first-aid" size="7x" />
                </div>
                <div class="col-lg-6 text-left ">
                    <h1 class="pt-5 pb-5">EHBO diensten</h1>
                    <h3><span class="text-muted">Vind bij Azurity de juiste ehbo-oplossing voor elke klus.</span></h3>
                    <div class="row mt-5">
                        <div class="col-md-12 mb-5">
                            <ul class="mb-5">
                                <li>
                                    <strong>EBHO</strong>
                                    <p>Altijd een gecertificeerde professional in de buurt met Eerste Hulp Bij Ongelukken (EHBO).</p>
                                </li>
                            </ul>
                            <register-buttons :sidebyside="false" type="EHBO-er"></register-buttons>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegisterButtons from '@/components/RegisterButtons';
export default {
    components: {
        RegisterButtons
    }
}
</script>

<style scoped>
</style>